<template>
  <div class="px--4">
    <el-skeleton
      :rows="10"
      :loading="isLoadingVideos && videos.length == 0"
      animated
    >
      <el-table
        :data="videos"
        style="width: 100%"
        row-key="id"
      >
        <el-table-column
          label="Id"
          prop="id"
          width="80"
        />
        <el-table-column
          label="Título"
          prop="title"
        />
        <el-table-column
          label="Módulo"
          prop="module_name"
        />
        <el-table-column
          label="Tipo de módulo"
          prop="module_type_text"
        />
        <el-table-column
          fixed="right"
          label="Conteúdos"
          width="180"
        >
          <template slot-scope="{ row }">
            <span class="d-flex justify-content-around">
              <el-tooltip
                class="item"
                effect="dark"
                content="Transcrição"
                placement="top-start"
              >
                <img 
                  src="/images/transcription.svg" 
                  alt="Vídeo"
                  width="20" 
                  height="20"
                  class="mx-1"
                  :class="{
                    'opacity-3' : !row.transcription
                  }"
                >
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="Capítulos"
                placement="top-start"
              >
                <img
                  src="/images/chapter.svg" 
                  alt="Vídeo"
                  width="20" 
                  height="20"
                  class="mx-1"
                  :class="{
                    'opacity-3' : !row.chapters
                  }"
                >
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="Subtópicos"
                placement="top-start"
              >
                <img 
                  src="/images/subtopic.svg" 
                  alt="Vídeo"
                  width="20" 
                  height="20"
                  class="mx-1"
                  :class="{
                    'opacity-3' : !row.subtopics
                  }"
                >
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="Resumo"
                placement="top-start"
              >
                <img 
                  src="/images/summary.svg" 
                  alt="Vídeo"
                  width="20" 
                  height="20"
                  class="mx-1"
                  :class="{
                    'opacity-3' : !row.summary
                  }"
                >
              </el-tooltip>
              
              <el-tooltip
                class="item"
                effect="dark"
                content="Questões"
                placement="top-start"
              >
                <img 
                  src="/images/quiz.svg" 
                  alt="Vídeo"
                  width="20" 
                  height="20"
                  class="mx-1"
                  :class="{
                    'opacity-3' : !row.questions
                  }"
                >
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="Ações"
          width="320"
        >
          <template slot-scope="{ row }">
            <slot :row="row" />
          </template>
        </el-table-column>
      </el-table>
    </el-skeleton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name:'VideoListComponent',
  computed:{
    ...mapGetters(['videos', 'isLoadingVideos']),
  },
}
</script>

<style>

</style>